import {Vue} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {plusIcon, editIcon} from '@deanone/dean-components';

@Component
export default class PeriodsSideMenuMixin extends Vue {
  public periods: any[] = [];

  public transformPeriods(periods: any[], destination: string) {
    const list: any[] = [];
    if (periods) {
      for (const period of periods) {
        period.title = period.label ? period.label : period.startDate + '-' + period.endDate;
        period.state = period.selected ? 'active' : '';
        period.name = destination;
        period.params = {
          startDate: period.startDate ?
            period.startDate : period.href.match(/startDate=(([0-9]){4}-([0-9]){2}-([0-9]){2})/)[1],
          endDate: period.endDate ?
            period.endDate : period.href.match(/endDate=(([0-9]){4}-([0-9]){2}-([0-9]){2})/)[1],
        };
        list.push(period);
      }
    }
    list.push({
      title: 'Periode wijzigen',
      name: 'StandingDataPeriodDialog',
      icon: editIcon,
      disabled: (!this.$route.params.startDate || !this.$route.params.endDate),
      params: {
        modal: true,
        view: 'period',
        context: 'recurringcommissionplan',
        contextId: this.$route.params.planId,
        existing: 1,
        oldStartDate: this.$route.params.startDate,
        oldEndDate: this.$route.params.endDate,
      },
    });
    list.push({
      title: 'Periode toevoegen',
      name: 'StandingDataPeriodDialog',
      icon: plusIcon,
      params: {
        modal: true,
        view: 'period',
        context: 'recurringcommissionplan',
        contextId: this.$route.params.planId,
      },
    });
    this.periods = list;
  }
}
